import { ArrowLeftIcon, XIcon } from "lucide-react";

import { Row, Text } from "@/components";
import { Button } from "@/components/ui/button";

import { SCREENING_PROMPT_KICKER_CLASSNAME } from "@/lib/constants";

// Shared top bar for the screening prompt's sub-steps — back to HOME on the
// left, dismiss the whole prompt on the right.
export const ScreeningStepHeader = ({
  title,
  onBack,
  onDismiss,
}: {
  title: string;
  onBack: () => void;
  onDismiss: () => void;
}) => {
  return (
    <Row className="items-center justify-between gap-2 border-b border-slate-200 bg-slate-50 px-2 py-1.5">
      <Row className="min-w-0 items-center gap-0.5">
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6 shrink-0 text-slate-400"
          onClick={onBack}
        >
          <ArrowLeftIcon className="h-3.5 w-3.5" />
        </Button>
        <Text truncate className={SCREENING_PROMPT_KICKER_CLASSNAME}>
          {title}
        </Text>
      </Row>
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6 shrink-0 text-slate-400"
        onClick={onDismiss}
      >
        <XIcon className="h-3.5 w-3.5" />
      </Button>
    </Row>
  );
};
